import React, { memo, useState } from "react";
import {
  Stack,
  Typography,
  Card,
  Box,
  Icon,
  DialogTitle,
  Dialog,
  DialogContent,
  IconButton,
} from "investira.react.components";
import FundosAbertosDetalhe from "./FundosAbertosDetalhe";

const FundosAbertos = memo((props) => {
  const { data } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card sx={{ flex: 1, display: "flex", minHeight: 0 }}>
        <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
          <Typography
            variant="caption"
            color="textPrimary"
            sx={{ fontWeight: 500 }}
          >
            Fundos Abertos
          </Typography>
          <Stack direction="column" justifyContent="flex-end">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-end"
            >
              <Typography variant="h5" color="textPrimary">
                <b>
                  {data.response?.resumo.estatisticas.quantidade_fundos_abertos}
                </b>
              </Typography>
              <Box
                sx={{ width: "16px", height: "16px", cursor: "pointer" }}
                onClick={() => setOpen(true)}
              >
                <Icon iconName={"others"} size={16} color="primary" />
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Card>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <DialogTitle>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            Fundos Abertos{" "}
            <IconButton color="primary" onClick={() => setOpen(false)}>
              <Icon iconName="cancel" size={21} />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ display: "flex" }}>
          <FundosAbertosDetalhe data={data} />
        </DialogContent>
      </Dialog>
    </>
  );
});

export default FundosAbertos;
